import React, { useState } from "react";
import { useCart } from "../context/CartContext";

export default function Header() {
  const { cartCount, openCart } = useCart();
  const [mobileOpen, setMobileOpen] = useState(false);

  const links = [
    ["#shop", "Shop"],
    ["#customize", "Design your mallet"],
    ["#play", "Play a chukka"],
    ["#repairs", "Repairs"],
    ["#contact", "Contact"],
  ];

  return (
    <header>
      <div className="wrap">
        <nav className="nav" aria-label="Main">
          <a className="brand" href="#top" aria-label="Aubone Polo Mallets home">
            <svg viewBox="0 0 64 64" aria-hidden="true"><circle cx="32" cy="32" r="30" fill="#D8D6D2" /><circle cx="34" cy="28" r="14" fill="#C81DD8" /><rect x="14" y="30" width="36" height="3" fill="#D8D6D2" /><rect x="14" y="36" width="36" height="3" fill="#D8D6D2" /><path d="M38 20 L48 14" stroke="#1C1A18" strokeWidth="3" strokeLinecap="round" /><path d="M36 19 l10 4" stroke="#1C1A18" strokeWidth="3" strokeLinecap="round" /></svg>
            AUBONE
          </a>
          <div className="nav-links">
            {links.map(([href, label]) => <a key={href} href={href}>{label}</a>)}
          </div>
          <button className="cart-btn" onClick={openCart} aria-label="Open cart">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 4h2l2.4 11.2a2 2 0 0 0 2 1.6h8.6a2 2 0 0 0 2-1.5L22 8H6" /><circle cx="10" cy="20" r="1.4" /><circle cx="18" cy="20" r="1.4" /></svg>
            <span>Cart</span><span className="count">{cartCount}</span>
          </button>
          <button className="menu-btn" aria-label="Menu" aria-expanded={mobileOpen} onClick={() => setMobileOpen(o => !o)}>
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 7h16M4 12h16M4 17h16" /></svg>
          </button>
        </nav>
        <div className={"mobile-nav" + (mobileOpen ? " open" : "")} onClick={(e) => { if (e.target.tagName === "A") setMobileOpen(false); }}>
          {links.map(([href, label]) => <a key={href} href={href}>{label}</a>)}
        </div>
      </div>
    </header>
  );
}
